import { render, staticRenderFns } from "./PrivateMessagesOnContactPage.vue?vue&type=template&id=654da2da&"
import script from "./PrivateMessagesOnContactPage.vue?vue&type=script&lang=js&"
export * from "./PrivateMessagesOnContactPage.vue?vue&type=script&lang=js&"
import style0 from "./PrivateMessagesOnContactPage.vue?vue&type=style&index=0&id=654da2da&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports